import React from 'react';
import { BeneficiaryCard, Icon } from '@fasstech/middle-design-system';
import { ControlledDatePicker } from '@@viewCommonComponents/controlled/index.js';
import { datePathTsToFr } from '@@viewHelpers/date.js';
import { filter, gte, has, inc, isEmpty, length, pathOr } from 'ramda';
import { mapIndexed } from '@@serverHelpers/index.mjs';
import TabsPagination from '@@viewCommonComponents/TabsPagination.jsx';

const AdherentInformations = ({
  customer,
  grantees,
  onModifyEffectDate,
  getMiddleText,
  getMiddleBoolean,
  form,
  updateVisibility,
  isButtonDisabled,
  displayTabsPagination,
  tabs,
  currentIndex,
  setCurrentIndex
}) => {
  const allCards = [
    customer,
    ...(getMiddleBoolean('BENEFICIAIRE_DONNEES_CONTRAT_EST_NECESSAIRE') ? grantees : [])
  ];

  const isFirst = currentIndex === 0;
  const isLast = currentIndex === allCards.length - 1;

  const handlePrev = () => {
    if (!isFirst) setCurrentIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    if (!isLast) setCurrentIndex((prev) => prev + 1);
  };

  const granteeTabs = filter(has('tag'), tabs);

  const displayIcons = gte(length(grantees), 1);
  return (
    <div className="flex flex-col gap-4 relative">
      {/* Desktop */}
      <div className="md:grid-cols-[auto_1fr] justify-center md:gap-4 md:flex hidden">
        <div className={'w-[220px]'}>
          <ControlledDatePicker
            label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
            withIndicator={false}
            name="offer.effectDate"
            form={form}
            disabled={true}
            onClick={onModifyEffectDate}
            data-testid="PROCESSDEVENTE_DATE_EFFET"
          />
        </div>

        <div className={'col-span-1 flex gap-4'}>
          {displayTabsPagination && (
            <TabsPagination
              updateVisibility={updateVisibility}
              isButtonDisabled={isButtonDisabled}
            />
          )}
          {customer && (
            <BeneficiaryCard
              icon={'informations_adherent'}
              title={getMiddleText('CLIENT_TITLE')}
              subtitle={'Date de naissance'}
              value={datePathTsToFr('birthDate', customer)}
            />
          )}
          {getMiddleBoolean('BENEFICIAIRE_DONNEES_CONTRAT_EST_NECESSAIRE') &&
            mapIndexed((tab, index) => {
              const indexBeneficiary = inc(index);
              return (
                <BeneficiaryCard
                  key={index}
                  icon={'informations_beneficiaire'}
                  title={getMiddleText('BENEFICIAIRE_LABEL_TITRE_GLOBAL', {
                    index: indexBeneficiary
                  })}
                  subtitle={'Date de Naissance'}
                  value={datePathTsToFr('birthDate', grantees[index])}
                  tag={getMiddleText(
                    `BENEFICIAIRE_TYPE_${pathOr('', [index, 'type'], grantees)}_LABEL`
                  )}
                  isDisplayed={isEmpty(tab.className)}
                />
              );
            }, granteeTabs)}
        </div>
      </div>

      {/* Mobile */}
      <div className="md:hidden relative w-full">
        <ControlledDatePicker
          name="offer.effectDate"
          label={getMiddleText('PROCESSDEVENTE_EFFECT_DATE_PLACEHOLDER')}
          form={form}
          disabled={true}
          data-testid="PROCESSDEVENTE_DATE_EFFET"
        />

        {displayIcons && (
          <Icon
            name={isFirst ? 'circle_left_chevron_inactive' : 'circle_left_chevron'}
            onClick={() => {
              !isFirst && handlePrev();
            }}
            size={44}
            fillClassName={!isFirst ? 'cursor-pointer hover:fill-primary duration-200' : ''}
            className={'absolute left-2 top-1/2 transform z-50 -translate-y-1/2 p-2'}
          />
        )}

        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-300"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
            {allCards.map((item, index) => (
              <div key={index} className="w-full shrink-0 flex justify-center">
                <BeneficiaryCard
                  icon={index === 0 ? 'informations_adherent' : 'informations_beneficiaire'}
                  title={
                    index === 0
                      ? getMiddleText('CLIENT_TITLE')
                      : getMiddleText('BENEFICIAIRE_LABEL_TITRE_GLOBAL', { index })
                  }
                  subtitle={'Date de Naissance'}
                  value={datePathTsToFr('birthDate', item)}
                  tag={index !== 0 ? getMiddleText(`BENEFICIAIRE_TYPE_${item.type}_LABEL`) : null}
                />
              </div>
            ))}
          </div>
        </div>

        {displayIcons && (
          <Icon
            name={isLast ? 'circle_right_chevron_inactive' : 'circle_right_chevron'}
            onClick={() => {
              !isLast && handleNext();
            }}
            size={44}
            fillClassName={!isLast && 'cursor-pointer hover:fill-primary duration-200'}
            className={'absolute right-2 top-1/2 transform -translate-y-1/2 p-2'}
          />
        )}
      </div>
    </div>
  );
};

export default AdherentInformations;
